export const ADD_LEADS = 'ADD_LEADS';
export const REMOVE_LEADS = 'REMOVE_LEADS';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const RESET_LEADS_LIST = 'RESET_LEADS_LIST';

interface ActionTypes {
  ADD_LEADS: string;
  REMOVE_LEADS: string;
  SET_CURRENT_PAGE: string;
  RESET_LEADS_LIST: string;
}

export interface Message {
  listId?: string;
  userKey?: string[];
  userId?: any[];
  currentPage?: number;
  //This determines whether the list is viewed in Explore or in the Individual List component
  //See the resetLeadsList function down below
  viewType?: string;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: Message;
}

export function addLeads(newMessage: Message): IndividualListActionTypes {
  return {
    type: ADD_LEADS,
    payload: newMessage,
  };
}

export function removeLeads(newMessage: Message): IndividualListActionTypes {
  return {
    type: REMOVE_LEADS,
    payload: newMessage,
  };
}

export function setCurrentPage(newMessage: Message): IndividualListActionTypes {
  return {
    type: SET_CURRENT_PAGE,
    payload: newMessage,
  };
}

export function resetLeadsList(newMessage: Message): IndividualListActionTypes {
  return {
    type: RESET_LEADS_LIST,
    payload: newMessage,
  };
}

export type IndividualListActionTypes = MessageAction;
try {
    // @ts-ignore
    addLeads.displayName = "addLeads";
    // @ts-ignore
    addLeads.__docgenInfo = { "description": "", "displayName": "addLeads", "props": { "listId": { "defaultValue": null, "description": "", "name": "listId", "required": false, "type": { "name": "string" } }, "userKey": { "defaultValue": null, "description": "", "name": "userKey", "required": false, "type": { "name": "string[]" } }, "userId": { "defaultValue": null, "description": "", "name": "userId", "required": false, "type": { "name": "any[]" } }, "currentPage": { "defaultValue": null, "description": "", "name": "currentPage", "required": false, "type": { "name": "number" } }, "viewType": { "defaultValue": null, "description": "", "name": "viewType", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/AudienceExplore/actions/individuallist.actions.ts#addLeads"] = { docgenInfo: addLeads.__docgenInfo, name: "addLeads", path: "src/shared/containers/AudienceExplore/actions/individuallist.actions.ts#addLeads" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    removeLeads.displayName = "removeLeads";
    // @ts-ignore
    removeLeads.__docgenInfo = { "description": "", "displayName": "removeLeads", "props": { "listId": { "defaultValue": null, "description": "", "name": "listId", "required": false, "type": { "name": "string" } }, "userKey": { "defaultValue": null, "description": "", "name": "userKey", "required": false, "type": { "name": "string[]" } }, "userId": { "defaultValue": null, "description": "", "name": "userId", "required": false, "type": { "name": "any[]" } }, "currentPage": { "defaultValue": null, "description": "", "name": "currentPage", "required": false, "type": { "name": "number" } }, "viewType": { "defaultValue": null, "description": "", "name": "viewType", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/AudienceExplore/actions/individuallist.actions.ts#removeLeads"] = { docgenInfo: removeLeads.__docgenInfo, name: "removeLeads", path: "src/shared/containers/AudienceExplore/actions/individuallist.actions.ts#removeLeads" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setCurrentPage.displayName = "setCurrentPage";
    // @ts-ignore
    setCurrentPage.__docgenInfo = { "description": "", "displayName": "setCurrentPage", "props": { "listId": { "defaultValue": null, "description": "", "name": "listId", "required": false, "type": { "name": "string" } }, "userKey": { "defaultValue": null, "description": "", "name": "userKey", "required": false, "type": { "name": "string[]" } }, "userId": { "defaultValue": null, "description": "", "name": "userId", "required": false, "type": { "name": "any[]" } }, "currentPage": { "defaultValue": null, "description": "", "name": "currentPage", "required": false, "type": { "name": "number" } }, "viewType": { "defaultValue": null, "description": "", "name": "viewType", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/AudienceExplore/actions/individuallist.actions.ts#setCurrentPage"] = { docgenInfo: setCurrentPage.__docgenInfo, name: "setCurrentPage", path: "src/shared/containers/AudienceExplore/actions/individuallist.actions.ts#setCurrentPage" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    resetLeadsList.displayName = "resetLeadsList";
    // @ts-ignore
    resetLeadsList.__docgenInfo = { "description": "", "displayName": "resetLeadsList", "props": { "listId": { "defaultValue": null, "description": "", "name": "listId", "required": false, "type": { "name": "string" } }, "userKey": { "defaultValue": null, "description": "", "name": "userKey", "required": false, "type": { "name": "string[]" } }, "userId": { "defaultValue": null, "description": "", "name": "userId", "required": false, "type": { "name": "any[]" } }, "currentPage": { "defaultValue": null, "description": "", "name": "currentPage", "required": false, "type": { "name": "number" } }, "viewType": { "defaultValue": null, "description": "", "name": "viewType", "required": false, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/AudienceExplore/actions/individuallist.actions.ts#resetLeadsList"] = { docgenInfo: resetLeadsList.__docgenInfo, name: "resetLeadsList", path: "src/shared/containers/AudienceExplore/actions/individuallist.actions.ts#resetLeadsList" };
}
catch (__react_docgen_typescript_loader_error) { }